const passwordValidation = () => {
  // Password validation
  const password = document.getElementById("user_password") as HTMLInputElement;
  const emailInput = document.getElementById("user_email") as HTMLInputElement;
  const form = document.querySelector(".account-form") as HTMLFormElement;

  // Password validation elements
  const passLower = document.getElementById("pass-lower");
  const passUpper = document.getElementById("pass-upper");
  const passNumber = document.getElementById("pass-number");
  const passLength = document.getElementById("pass-length");
  const passwordContainer = document.getElementById("password-contain");

  // Initialize all requirements with X mark
  [passLower, passUpper, passNumber, passLength].forEach(elem => {
    if (elem) {
      elem.classList.add("invalid-requirement");
    }
  });

  // Show password requirements when password field is focused
  if (password) {
    password.addEventListener("focus", () => {
      if (passwordContainer) {
        passwordContainer.style.display = "block";
      }
    });

    // Validate password as user types
    password.addEventListener("input", () => {
      const value = password.value;

      // Validate lowercase letters
      if (passLower) {
        if (value.match(/[a-z]/g)) {
          passLower.classList.remove("invalid-requirement");
          passLower.classList.add("valid-requirement");
        } else {
          passLower.classList.remove("valid-requirement");
          passLower.classList.add("invalid-requirement");
        }
      }

      // Validate uppercase letters
      if (passUpper) {
        if (value.match(/[A-Z]/g)) {
          passUpper.classList.remove("invalid-requirement");
          passUpper.classList.add("valid-requirement");
        } else {
          passUpper.classList.remove("valid-requirement");
          passUpper.classList.add("invalid-requirement");
        }
      }

      // Validate numbers
      if (passNumber) {
        if (value.match(/[0-9]/g)) {
          passNumber.classList.remove("invalid-requirement");
          passNumber.classList.add("valid-requirement");
        } else {
          passNumber.classList.remove("valid-requirement");
          passNumber.classList.add("invalid-requirement");
        }
      }

      // Validate length
      if (passLength) {
        if (value.length >= 8) {
          passLength.classList.remove("invalid-requirement");
          passLength.classList.add("valid-requirement");
        } else {
          passLength.classList.remove("valid-requirement");
          passLength.classList.add("invalid-requirement");
        }
      }
    });
  }

  // Form validation
  if (form) {
    form.addEventListener("submit", (e) => {
      let isValid = true;

      // Validate email
      if (emailInput) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(emailInput.value)) {
          emailInput.setCustomValidity("Please enter a valid email address");
          isValid = false;
        } else {
          emailInput.setCustomValidity("");
        }
      }

      // Validate password
      if (password) {
        const value = password.value;
        if (!(value.length >= 8 &&
              value.match(/[a-z]/g) &&
              value.match(/[A-Z]/g) &&
              value.match(/[0-9]/g))) {
          password.setCustomValidity("Password must meet all requirements");
          isValid = false;
        } else {
          password.setCustomValidity("");
        }
      }

      if (!isValid) {
        e.preventDefault();
      }
    });
  }
}

export default passwordValidation;

